/**
 * CSV for a chart's plotted data (D529). RFC 4180 quoting, CRLF line ends, and a guard against spreadsheet formula
 * injection: a TEXT cell that starts with `=`, `+`, `-`, `@`, a tab or a carriage return gets a leading apostrophe-free
 * neutralisation (a single quote), so opening the file in a spreadsheet never runs a formula that came from data. Numbers
 * are written as plain `String(n)`, so a negative number stays a number.
 */
import { isFiniteNumber } from './numbers.js';
const FORMULA_START = /^[=+\-@\t\r]/;
/** One cell as CSV text. */
export function csvCell(cell) {
    if (cell === null || cell === undefined)
        return '';
    if (typeof cell === 'number')
        return isFiniteNumber(cell) ? String(cell) : '';
    const text = FORMULA_START.test(cell) ? `'${cell}` : cell;
    return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}
/** A header row and data rows as CSV text (CRLF-terminated lines, no BOM). */
export function toCsv(header, rows) {
    const lines = [header.map(csvCell).join(','), ...rows.map((r) => r.map(csvCell).join(','))];
    return `${lines.join('\r\n')}\r\n`;
}
/** A safe file name from free text: letters, digits, dash and underscore only (anything else becomes a dash), at most 64 chars. */
export function safeFileName(name, fallback = 'chart') {
    const cleaned = name
        .normalize('NFKD')
        .replace(/\p{M}+/gu, '')
        .replace(/[^\p{L}\p{N}_-]+/gu, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 64);
    return cleaned === '' ? fallback : cleaned;
}
//# sourceMappingURL=csv.js.map